import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Gallery } from './routes/Gallery'
import { Album } from './routes/Album'
import { Admin } from './routes/Admin'
import { NotFound } from './routes/NotFound'

// three.js is most of the bundle and only the viewer needs it, so the gallery
// and admin pages don't pay for it.
const Viewer = lazy(() => import('./routes/Viewer').then((m) => ({ default: m.Viewer })))

export function App(): JSX.Element {
  return (
    <Suspense
      fallback={
        <main className="page page--centered">
          <span className="spinner" aria-hidden="true" />
        </main>
      }
    >
      <Routes>
        <Route path="/" element={<Gallery />} />
        {/* Slugs are decorative on both; the id is what resolves. */}
        <Route path="/albums/:id" element={<Album />} />
        <Route path="/albums/:id/:slug" element={<Album />} />
        <Route path="/photos/:id" element={<Viewer />} />
        <Route path="/photos/:id/:slug" element={<Viewer />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
